import { EditorContainer } from '@modules/editor/EditorContainer';
import { styled } from '@mui/material';
import { Editor, EditorContent } from '@tiptap/react';
import { CONTAINER_PADDING } from './constants';

const EditorContainerStyled = styled(EditorContainer)(
  ({ theme }) => `
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      scroll-margin-top: 150px;
    }

    & .ProseMirror {
      padding-right: 0;
      &:focus {
        box-shadow: none !important;
      }
      ${theme.breakpoints.up('sm')} {
        padding: ${theme.spacing(0, CONTAINER_PADDING)};
      }
    }
`,
);

type Props = {
  editor: Editor;
};

export const DocContentEditor = ({ editor }: Props) => (
  <EditorContainerStyled editor={editor}>
    <EditorContent editor={editor} />
  </EditorContainerStyled>
);
